var urlServer = 'https://api-suporte.trixlog.com';

var baseUrl = urlServer + '/tickets';

export default {
  baseUrl
}



// WEBPACK FOOTER //
// ./src/resources/Url.js